<div class="row p-2 mb-3 align-items-center">
  <div class="col-12 col-md-7 text-start">
    <div class="page-title-heading">
      <div class="page-title-icon"><i class="fa-solid fa-school"></i></div>
      <div>
        École
        <div class="page-title-subheading">Identité et coordonnées de l'établissement</div>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-5 text-end">
    <app-header></app-header>
  </div>
</div>
  


    

    <div class="row">
        <div class="col-lg-12">
            <div class="card">
                <form #addForm="ngForm" (ngSubmit)="setData(addForm.value)">
                        
                <div class="card-body">
                    <div class="text-center mb-1">
                        <img [src]="fileSrc" class="img-thumbnail" alt="..." style="height: 200px; width: 200px;">
                    </div>
                    <div class="text-center form-group mb-3">
                        <label for="">Charger le logo</label>
                        <input type="file" accept='image/*' (change)="loadImg($event)" class="form-control" />
                    </div>
                    <div class=" form-group col-12 mb-3">
                        <label for="">Libellé <span class="text-danger ml-2">(*)</span></label>
                        <input type="text" name="name"  class="form-control" [(ngModel)]="data.name">
                    </div>
                    <div class=" form-group col-12 mb-3">
                        <label for="">Sigle <span class="text-danger ml-2">(*)</span></label>
                        <input type="text" name="acronym" class="form-control"  [(ngModel)]="data.acronym">
                    </div>
                    <div class=" form-group col-12 mb-3">
                        <label for="">Email <span class="text-danger ml-2">(*)</span></label>
                        <input type="text" name="email" class="form-control"  [(ngModel)]="data.email">
                    </div>
                    <div class=" form-group col-12 mb-3">
                        <label for="">Contact <span class="text-danger ml-2">(*)</span></label>
                        <input type="text" name="phone" class="form-control"  [(ngModel)]="data.phone">
                    </div>
                    <div class=" form-group col-12 mb-3">
                        <label for="">Boîte postal <span class="text-danger ml-2">(*)</span></label>
                        <input type="text" name="postal_box" class="form-control"  [(ngModel)]="data.postal_box">
                    </div>
                    <div class=" form-group col-12 mb-3">
                        <label for="">Description <span class="text-danger ml-2">(*)</span></label>
                        <angular-editor [placeholder]="'Entrez le contenu'" [(ngModel)]="data.description" name="description" required></angular-editor>
                     </div>
                </div>

                <div class="card-footer">
                    <button type="submit" class="btn btn-outline-dark" [disabled]="addForm.invalid || loading"  >Sauvegarder les données <app-loading [isVisible]="loading"></app-loading></button>
                  </div>
              </form>
            </div>
        </div>
    </div>